import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import {
  RECRUITER_TOKEN_KEY, RECRUITER_USER_KEY, getRecruiterMe,
} from '../recruiterApi';

const RecruiterAuthContext = createContext(null);
export const useRecruiterAuth = () => useContext(RecruiterAuthContext);

function tokenValid(token) {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch { return false; }
}

export function RecruiterAuthProvider({ children }) {
  const [recruiter, setRecruiter] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(RECRUITER_TOKEN_KEY);
    if (!tokenValid(token)) {
      localStorage.removeItem(RECRUITER_TOKEN_KEY);
      localStorage.removeItem(RECRUITER_USER_KEY);
      setLoading(false);
      return;
    }
    try {
      const cached = JSON.parse(localStorage.getItem(RECRUITER_USER_KEY) || 'null');
      if (cached) setRecruiter(cached);
    } catch {}
    // Refresh from the server so status changes (e.g. approval) reflect on reload.
    getRecruiterMe()
      .then(({ recruiter: r }) => {
        if (r) { setRecruiter(r); localStorage.setItem(RECRUITER_USER_KEY, JSON.stringify(r)); }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback((token, rec) => {
    localStorage.setItem(RECRUITER_TOKEN_KEY, token);
    localStorage.setItem(RECRUITER_USER_KEY, JSON.stringify(rec));
    setRecruiter(rec);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(RECRUITER_TOKEN_KEY);
    localStorage.removeItem(RECRUITER_USER_KEY);
    setRecruiter(null);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { recruiter: r } = await getRecruiterMe();
      if (r) { setRecruiter(r); localStorage.setItem(RECRUITER_USER_KEY, JSON.stringify(r)); }
      return r;
    } catch { return null; }
  }, []);

  return (
    <RecruiterAuthContext.Provider
      value={{
        recruiter,
        loading,
        login,
        logout,
        refresh,
        isActive: recruiter?.status === 'active',
        needsCompany: !!recruiter && !recruiter.company,
      }}
    >
      {children}
    </RecruiterAuthContext.Provider>
  );
}
